<div *ngIf="isInDropdown && loading">
    <hc-progress-spinner [diameter]="48" [color]="'blue'"></hc-progress-spinner>
</div>
<div [class.source-switcher-large]="!isInDropdown" *ngIf="!(isInDropdown && loading)">
    <div class="source-switcher-search-container">
        <hc-search-bar
            #sourceSearch
            placeholder="Search sources..."
            [autoSearch]="true"
            (triggerSearch)="search($event)"
            (keydown)="onSearchKeydown($event)"
        ></hc-search-bar>
    </div>
    <div class="source-switcher-list-container">
        <cdp-grid-states
            nameSingular="source"
            namePlural="sources"
            [loading]="loading"
            [loadFailed]="loadingFailed"
            [searchValue]="sourceSearch.value"
            [dataSource]="sourcesDataSource"
            [allowAddNew]="false"
            (clearSearch)="sourceSearch.clear()"
            (refresh)="loadSources()"
        >
        </cdp-grid-states>

        <div
            #sourceRow
            tabindex="0"
            class="source-switcher-row active-source"
            [class.selected-source]="!selectedSourceId"
            (click)="selectSource()"
            title="View all sources"
            (keydown)="onRowKeydown($event)"
        >
            <span class="source-switcher-row-name">
                <span class="source-switcher-row-name-inner"> All sources</span>
            </span>
        </div>
        @for (source of sourcesDataSource.filteredData; track source.tenantSourceId) {
            <ng-container *ngTemplateOutlet="rowTemplate; context: { source: source }"></ng-container>
        }

        <ng-template #rowTemplate let-source="source">
            <div
                #sourceRow
                tabindex="0"
                class="source-switcher-row"
                [class.selected-source]="source.tenantSourceId === selectedSourceId"
                [class.active-source]="source.statusDisplay !== 'Inactive'"
                (click)="selectSource(source)"
                title="{{
                    source.tenantSourceId === selectedSourceId
                        ? 'Current source'
                        : 'Switch to this source (' + source.description + ')'
                }}"
                (keydown)="onRowKeydown($event, source)"
            >
                <span class="source-switcher-row-name">
                    <span class="icon-left {{ source.sourceIcon }}"></span>
                    <span
                        class="source-switcher-row-name-inner"
                        [innerHTML]="source.description | highlight: sourceSearch.value"
                    ></span>
                </span>
                <span class="source-switcher-row-status"
                    ><span class="cdp-dev-status-indicator cdp-dev-status-indicator-{{ source.status }}"></span
                    >{{ source.statusDisplay }}</span
                >
            </div>
        </ng-template>
    </div>
</div>
